module.exports = "/assets/52a0a9707ce872bc994d1d2f976fa637.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/SB.png
// module id = 2936
// module chunks = 0